import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
function normalizeSeverity(severity) {
    if (severity === "Critical" || severity === 2)
        return "critical";
    if (severity === "Warning" || severity === 1)
        return "warning";
    return "info";
}
function severityClass(severity) {
    switch (normalizeSeverity(severity)) {
        case "critical":
            return "danger";
        case "warning":
            return "warning";
        default:
            return "info";
    }
}
function severityIcon(severity) {
    switch (normalizeSeverity(severity)) {
        case "critical":
            return "fa fa-exclamation-triangle";
        case "warning":
            return "fa fa-exclamation-circle";
        default:
            return "fa fa-info-circle";
    }
}
function mapInsight(item) {
    return {
        title: item.Title,
        body: item.Body,
        severityIcon: severityIcon(item.Severity),
        severityClass: severityClass(item.Severity),
    };
}
export function FleetSummary({ options }) {
    const [isExpanded, setIsExpanded] = useState(true);
    const [isFetching, setIsFetching] = useState(false);
    const [hasResult, setHasResult] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [insights, setInsights] = useState([]);
    const isLoading = !options.isReady || isFetching;
    useEffect(() => {
        if (!options.isReady) {
            setHasResult(false);
            setIsFetching(false);
            setErrorMessage("");
            return;
        }
        setIsFetching(true);
        setHasResult(false);
        setErrorMessage("");
        const params = new URLSearchParams();
        params.append("year", String(options.year));
        params.append("quarter", String(options.quarter));
        options.fleetIds.forEach((id) => params.append("fleetIds", String(id)));
        fetch(`/api/insights/quarterly/actionable?${params}`)
            .then((res) => {
            if (res.status === 204)
                return [];
            if (res.ok)
                return res.json();
            throw new Error(res.statusText);
        })
            .then((data) => {
            setInsights(data.map(mapInsight));
            setHasResult(true);
        })
            .catch((e) => {
            console.error(e);
            setErrorMessage("Error fetching actionable insights");
        })
            .finally(() => setIsFetching(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options.isReady, options.year, options.quarter, options.fleetIds.join(",")]);
    return (_jsxs("div", { className: "card shadow", children: [_jsxs("div", { className: "card-header d-flex align-items-center", style: { cursor: "pointer" }, onClick: () => setIsExpanded(!isExpanded), children: [_jsx("h2", { className: "mb-0 flex-grow-1", children: "Fleet summary" }), _jsx("i", { className: `fa ${isExpanded ? "fa-chevron-up" : "fa-chevron-down"}` })] }), isExpanded && (_jsxs("div", { className: "card-body", children: [isLoading && (_jsxs("div", { className: "text-center py-4", children: [_jsx("span", { className: "spinner-grow spinner-grow-sm", role: "status", "aria-hidden": "true" }), " Loading..."] })), options.isReady && errorMessage && (_jsx("div", { className: "alert alert-danger", role: "alert", children: errorMessage })), hasResult && !isLoading && insights.length === 0 && (_jsx("p", { className: "text-muted mb-0", children: "No actionable insights for this period." })), hasResult && !isLoading && insights.length > 0 && (_jsx("div", { className: "list-group list-group-flush", children: insights.map((insight, index) => (_jsxs("div", { className: "list-group-item d-flex align-items-start", children: [_jsx("i", { className: `${insight.severityIcon} me-2 mt-1 text-${insight.severityClass}` }), _jsxs("div", { children: [_jsx("strong", { children: insight.title }), _jsx("p", { className: "mb-0 text-muted", children: insight.body })] })] }, index))) }))] }))] }));
}
